export default __webpack_public_path__ + "static/combination-of-different-series-types-65e93cabfc2d757c1b3acbd63be579c8.png";